<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增主分类"
				fontSize="14px" @btnclick="adduser">
			</Commonbtn>
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增子分类"
				fontSize="14px" @btnclick="adduser2">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')"
				title="修改" fontSize="14px" :useAutoOptional="false" :optional="handleList.length !== 1" @btnclick="updateclick">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除"
				fontSize="14px" @btnclick="del">
			</Commonbtn>
		</div>
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" @handleSelectionChange="handleSelectionChange" ref="dataManageRef" colnum=522 :tableData="tableData"
				:headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total" :pageSize="pageSize"></Pagination>
			</div>
		</div>
		<DialogFrom style="scollo" width="800px" title="新增主分类" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrs" ref="Manageadd"></FromComm>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom style="scollo" width="800px" title="新增子分类" :dialogVisible="dialogVisibleObject"
			@cancel="cancelObject" @dialogOK="dialogOKObject">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrsChild" ref="Manageadd" @selectAll="selectAll" @removeTag="removeTag"
						@InforSelectChange="InforSelectChange" @remoteMethod="remoteMethod"></FromComm>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="800px" title="修改主分类" :dialogVisible="dialogVisibleseditm"
			@cancel="dialogVisibleseditm = false" @dialogOK="dialogOKeditm">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrs" ref="Manageadd"></FromComm>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="800px" title="修改子分类" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrsChild" ref="Manageadd"></FromComm>
				</div>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该分类吗？</span>
		</Dialog>

	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Dialog from '../../../../components/dialog.vue'
	import CommonUploadEnclosure from '../../../../components/common-upload-Enclosure.vue'
	import CommUploadAdditional from '../../../../components/comm-upload-additional.vue'
	import FromArr from '../fromData/FromArr'
	import FromArrChild from '../fromData/FromArrChild'
	import fromdataedit from '../fromData/edit'
	import SearchComm from '../../../../components/comm-from-search.vue'
	import {
		InventoryClassList,
		HelperGetUserNameAndRole
	} from '@/api/home'
	import {
		DataDownloadClassList,
		DataDownloadClassAdd,
		DataDownloadClassEdit,
		DataDownloadClassDelete,
		DataDownloadClassInfo,
		DataDownloadUpLoadAttachment,
	} from '@/api/channel'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonUploadEnclosure,
			CommUploadAdditional,
			FromComm,
			SearchComm
		},
		props: {

		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibleqy: false,
				dialogVisibleObject: false,
				choseAllFlag: false,
				total: 0,
				pageSize: 10,
				pageindex: 1,
				totalchoiceObject: 0,
				pageSizeObject: 10,
				pageIndexObject: 1,
				username: '',
				name: '',
				ptype: '',
				type: '',
				zname: '',
				parentId: '',
				DDCode: '',
				handleList: [],
				ChoseObjectName: '',
				choseAllTitle: '全部选择',
				rowboo: false,
				FromArrs: [],
				fromdataedit: [],
				fileData: null,
				resdetailsList: {},
				qus: [],
				tableData: [],
				invClassList: [],
				RoleList: [],
				UserList: [],
				Objects: [],
				tableDataInvClass: [],
				headerDataInvClass: [{
					prop: 'ObjectName',
					label: '产线',
					columnwidth: 180
				}, ],
				tableDataUser: [],
				headerDataUser: [{
						prop: 'ObjectID',
						label: '用户名',
						columnwidth: 180
					},
					{
						prop: 'ObjectName',
						label: '用户名称',
						columnwidth: 180
					},
				],
				tableDataRole: [],
				headerDataRole: [{
					prop: 'ObjectName',
					label: '角色',
					columnwidth: 180
				}, ],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false
				},
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 80
					},
					{
						prop: 'MainName',
						label: '主分类名称',
						columnwidth: 170
					},
					{
						prop: 'ChildName',
						label: '子分类名称',
						columnwidth: 200
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 200
					},
					{
						prop: 'Remark',
						label: '分类备注',
						columnwidth: 200
					},
					{
						prop: 'CreatorName',
						label: '创建人'
					},
					{
						prop: 'CreateTime',
						label: '发布时间'
					},
				],
				FromArrsChild: [],
				dialogVisibleseditm: false,
				Grade: 1,
			}
		},
		created() {
			this.DataDownloadListApi()
			this.InventoryClassList();
		},
		mounted() {
			this.FromArrs = JSON.parse(JSON.stringify(FromArr));
			this.FromArrsChild = JSON.parse(JSON.stringify(FromArrChild))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus.map((item, index) => {
					if (item.NodeID == 74) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 75) {
								this.qus = items.Nodes
							}
						})
					}
				})
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					}
				})

			},
			// 上传附件
			async DataDownloadUpLoadAttachment(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await DataDownloadUpLoadAttachment(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.fileData = res.data
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						//    this.dialogVisiblesdrjg = true
						// this.tableDatadrjg = res.data
						// this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			async DataDownloadListApi() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await DataDownloadClassList({
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			async DataDownloadMainType() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassList({
					Grade: 1
				})
				if (code == 0) {
					let maps = [];
					data.data.map(item => {
						maps.push({
							key: item.DDCode,
							value: item.MainName
						})
					})
					this.FromArrsChild[0].options = maps
				} else {
					this.$message.warning(message)
				}
			},
			//获取产品线
			async InventoryClassList() {
				let {
					code,
					message,
					data
				} = await InventoryClassList({
					pageSize: 9999
				})
				if (code == 0) {
					let maps = [];
					data.data.map(item => {
						maps.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
					this.FromArrs[2].options = maps
					this.FromArrsChild[3].options = maps
				} else {
					this.$message.warning(message)
				}
			},
			// 新增
			async DataDownloadAdd() {
				if (!this.FromArrs[0].modelvalue) {
					this.$message({
						type: 'error',
						message: '请输入主分类名称'
					});
					return
				}
				// if (!this.FromArrs[1].modelvalue) {
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入分类备注'
				// 	});
				// 	return
				// }
				let {
					code,
					message,
					data
				} = await DataDownloadClassAdd({
					DDName: this.FromArrs[0].modelvalue,
					ParentCode: '',
					Remark: this.FromArrs[1].modelvalue,
					InvClass: this.FromArrs[2].modelvalue.join(','),
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.DataDownloadListApi()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}

			},
			//详情
			async DataDownloadInfo() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassInfo({
					DDCode: this.DDCode
				})
				if (code == 0) {
					if (this.Grade === 1) {
						this.FromArrs[0].modelvalue = data.MainName
						this.FromArrs[1].modelvalue = data.Remark
						this.FromArrs[2].modelvalue = data.InvClass.split(',')
					} else {
						this.FromArrsChild[0].modelvalue = data.DDCode
						this.FromArrsChild[0].options = [{
							key: data.DDCode,
							value: data.MainName
						}]
						this.FromArrsChild[1].modelvalue = data.ChildName
						this.FromArrsChild[2].modelvalue = data.Remark
						this.FromArrsChild[3].modelvalue = data.InvClass.split(',')
					}
				}
			},
			// 修改
			async DataDownloadEdit() {
				if (!this.FromArrsChild[1].modelvalue) {
					this.$message({
						type: 'error',
						message: '请输入子分类名称'
					});
					return
				}
				// if (!this.FromArrsChild[2].modelvalue) {
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入分类备注'
				// 	});
				// 	return
				// }
				let {
					code,
					message,
					data
				} = await DataDownloadClassEdit({
					DDCode: this.FromArrsChild[0].modelvalue,
					DDName: this.FromArrsChild[1].modelvalue,
					Remark: this.FromArrsChild[2].modelvalue,
					InvClass: this.FromArrsChild[3].modelvalue.join(','),
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesedit = false
					this.DataDownloadListApi()
					this.rowboo = false
					this.$refs.dataManageRef.$refs.fileTableSelect.setCurrentRow('');
				} else {
					this.$message.warning(message)
				}
			},
			// 删除
			async DataDownloadDelete() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassDelete({
					DDCode: this.DDCode
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesedit = false
					this.rowboo = false
					this.DataDownloadListApi()
				} else {
					this.$message.warning(message)
				}
			},
			onRowClick(val) {
				this.rowboo = true
				this.Grade = val.Grade;
				this.DDCode = val.DDCode
			},
			handleSelectionChange(val) {
				this.handleList = val
				if (val.length === 1) {
					this.rowboo = true
					this.Grade = val[0].Grade
					this.DDCode = val[0].DDCode
					return
				}
				this.rowboo = false
				if (val.length === 0) {
					this.DDCode = ''
				}
			},
			adduser() {
				this.dialogVisibles = true
			},
			adduser2() {
				this.dialogVisibleObject = true
				this.FromArrsChild[0].disabled = false;
				this.DataDownloadMainType();
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.DataDownloadAdd()
				this.dialogVisibles = false
			},
			updateclick() {
				if (this.handleList.length === 1) {
					this.rowboo = true
					this.Grade = this.handleList[0].Grade
					this.DDCode = this.handleList[0].DDCode
					if (this.Grade === 1) {
						this.dialogVisibleseditm = true;
						this.DataDownloadInfo()
					} else {
						this.dialogVisiblesedit = true
						this.FromArrsChild[0].disabled = true;
						this.DataDownloadInfo()
					}
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.DataDownloadEdit()
			},
			async dialogOKeditm() {
				if (!this.FromArrs[0].modelvalue) {
					this.$message({
						type: 'error',
						message: '请输入主分类名称'
					});
					return
				}
				// if (!this.FromArrs[1].modelvalue) {
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入分类备注'
				// 	});
				// 	return
				// }
				let {
					code,
					message,
					data
				} = await DataDownloadClassEdit({
					DDCode: this.DDCode,
					DDName: this.FromArrs[0].modelvalue,
					Remark: this.FromArrs[1].modelvalue,
					InvClass: this.FromArrs[2].modelvalue.join(','),
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleseditm = false
					this.DataDownloadListApi()
					this.rowboo = false
					this.$refs.dataManageRef.$refs.fileTableSelect.setCurrentRow('');
				} else {
					this.$message.warning(message)
				}
			},
			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true

					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.DataDownloadDelete()
				this.dialogVisibledel = false
			},
			handleCurrentChange(PageIndex) {
				this.pageindex = PageIndex
				this.DataDownloadListApi()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.DataDownloadListApi()
			},
			// // 全选
			selectAll() {
				if (this.FromArrs[1].modelvalue.length < this.FromArrs[1].options.length) {
					this.FromArrs[1].modelvalue = []
					this.FromArrs[1].options.map((item) => {
						this.FromArrs[1].modelvalue.push(item.value)
					})
					this.FromArrs[1].modelvalue.unshift('全选')
				} else {
					this.FromArrs[1].modelvalue = []
				}
			},
			// 多选的Change事件
			InforSelectChange(e) {
				if (!e.FromArr[1].modelvalue.includes('全选') && e.FromArr[1].modelvalue.length === this.FromArrs[1].options
					.length) {
					this.FromArrs[1].modelvalue.unshift('全选')
				} else if (e.FromArr[1].modelvalue.includes('全选') && (e.FromArr[1].modelvalue.length - 1) < this.FromArrs[
						1].options.length) {
					this.FromArrs[1].modelvalue = this.FromArrs[1].modelvalue.filter((item) => {
						return item !== '全选'
					})
				}
			},
			// 删除全选选项全部删除
			removeTag(val) {
				if (val === '全选') {
					this.FromArrs[1].modelvalue = []
				}
			},
			remoteMethod(val) {
				if (val.parsign == 'PublishremoteMethod') {
					this.HelperGetUserNameAndRole(val.qurey)
				}
				console.log(val, 'qurey');
			},
			chose() {
				this.dialogVisibleObject = true
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				setTimeout(() => {
					this.HelperGetUserNameAndRole()
					this.HelperGetUserNameAndRoleInvClass()
					this.HelperGetUserNameAndRoleUserName()
					loading.close()
				}, 100)
			},
			cancelObject() {
				this.dialogVisibleObject = false
			},
			async dialogOKObject() {
				if (!this.FromArrsChild[0].modelvalue) {
					this.$message({
						type: 'error',
						message: '请选择主分类名称'
					});
					return
				}
				if (!this.FromArrsChild[1].modelvalue) {
					this.$message({
						type: 'error',
						message: '请输入字分类名称'
					});
					return
				}
				// if (!this.FromArrsChild[2].modelvalue) {
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入分类备注'
				// 	});
				// 	return
				// }
				let {
					code,
					message,
					data
				} = await DataDownloadClassAdd({
					ParentCode: this.FromArrsChild[0].modelvalue,
					DDName: this.FromArrsChild[1].modelvalue,
					Remark: this.FromArrsChild[2].modelvalue,
					InvClass: this.FromArrsChild[3].modelvalue.join(','),
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.dialogVisibleObject = false
					this.DataDownloadListApi()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			onRowClickLeftTable(val) {

			},
			searchClick(val) {
				this.ChoseObjectName = val
				this.HelperGetUserNameAndRoleUserName()
			},
			handleSelectionChangeleftTop(val) {
				this.invClassList = val
			},
			handleSelectionChangeleftBottom(val) {
				console.log(val);
				this.RoleList = val
			},
			handleSelectionChangeRight(val) {
				this.UserList = val
			},
			handleCurrentChangechoiceObject(pageIndex) {
				this.pageIndexObject = pageIndex
				this.HelperGetUserNameAndRoleUserName()
			},
			handleSizeChangechoiceObject(pageSize) {
				this.pageSizeObject = pageSize
				this.HelperGetUserNameAndRoleUserName()
			},
			ChoseAll() {
				this.choseAllFlag = !this.choseAllFlag
				if (this.choseAllFlag) {
					this.choseAllTitle = '取消选择'
					this.$nextTick(() => {
						for (let i = 0; i < this.tableDataInvClass.length; i++) {
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.toggleRowSelection(this
								.tableDataInvClass[i], true);
						}
						for (let i = 0; i < this.tableDataRole.length; i++) {
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.toggleRowSelection(this
								.tableDataRole[i], true);
						}
						for (let i = 0; i < this.tableDataUser.length; i++) {
							this.$refs.choiceObjectTableRight.$refs.fileTable555.toggleRowSelection(this
								.tableDataUser[i], true);
						}
					})
				} else {
					this.choseAllTitle = '全部选择'
					this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
					this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
					this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();

				}

			},
		},
		watch: {
			dialogVisibles: {
				handler(newVal, oldVal) {
					if (newVal == true) {
						this.fileData = null,
							this.FromArrs.map((item, index) => {
								item.modelvalue = ''
							})
						this.Objects = []
						try {
							this.choseAllFlag = false
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
						} catch (error) {

						}
					}
				}
			},
			dialogVisiblesedit: {
				handler(newVal, oldVal) {
					if (newVal == true) {
						this.fileData = null,
							this.FromArrs.map((item, index) => {
								item.modelvalue = ''
							})
						this.choseAllFlag = false

					}
				}
			},
			dialogVisibleObject: {
				handler(newValue, oldValue) {
					if (newValue == true) {
						try {
							this.choseAllFlag = false
							this.FromArrsChild.map((item, index) => {
								item.modelvalue = ''
							})
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
						} catch (error) {

						}

					}
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 20px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// flex-wrap: wrap;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.choseBtn {
		position: absolute;
		top: 105px;
		left: 900px;
	}

	.choiceObject {
		width: 946px;
		height: 100%;
		// border: 1px solid red;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		font-weight: normal;
		color: #333333;
		line-height: 20px;

		.leftTitle {
			width: 230px;
			font-size: 14px;

			overflow: hidden;

			.leftTable {
				margin-left: -10px;
				margin-top: 20px;
			}
		}

		.paginationChose {
			position: relative;
			right: 60px;
			top: 50px;
		}

		.rightTitles {
			width: 710px;
			font-size: 14px;

			.rightSearch {
				position: relative;
				top: -45px;
				left: -350px;
			}

			.rightBtn {
				position: absolute;
				top: 50px;
				left: 650px;
			}

			.leftTable {
				margin-left: -10px;
				margin-top: 20px;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
